import Marionette from 'backbone.marionette';
import EmptyQuickBagTemplate from '../templates/partials/quick-bag/emptyQuickBag.hbs';

export default Marionette.ItemView.extend({
  template: EmptyQuickBagTemplate,
  el: 'div.quickBagEmpty',

  initialize(options) {
    if (options.loadingError) {
      this.model.set('loadingError', options.loadingError);
    }
  },
});
